import { subscriptionCollection, licensedUserUsage } from '@/db/firestore';

const maxFreeDecks: number = 3;
const maxFreeCards: number = 30;

export class Licensing {
    private async isSubscribed(userId: string): Promise<boolean> {
        try {
            const query = await subscriptionCollection.where('userId', '==', userId).where('active', '==', true).get();
            return new Promise((resolve, reject) => {
                resolve(query.docs.length > 0);
            });
        } catch (error) {
            console.log(`Couldn't get subscription information`);
            console.error(error);
            return new Promise((resolve, reject) => { reject(error); });
        }
    }
    public async canAddDeck(userId: string): Promise<boolean> {
        const subscribed = await this.isSubscribed(userId);
        if (subscribed) {
            return new Promise((resolve, reject) => resolve(true));
        } else {
            try {
                const usage = await licensedUserUsage.doc(userId).get();
                return new Promise((resolve, reject) => {
                    resolve(usage.data().deckCount < maxFreeDecks);
                });
            } catch (error) {
                console.log(`Couldn't get license information`);
                console.error(error);
                return new Promise((resolve, reject) => resolve(error));
            }
        }
    }

    public async canAddCard(userId: string, card_count: number): Promise<boolean> {
        const subscribed = await this.isSubscribed(userId);
        if (subscribed) {
            return new Promise((resolve, reject) => resolve(true));
        } else {
            try {
                return new Promise((resolve, reject) => {
                    resolve(card_count < maxFreeCards);
                });
            } catch (error) {
                console.log(`Couldn't get license information`);
                console.error(error);
                return new Promise((resolve, reject) => resolve(error));
            }
        }
    }
}
